import { useState, useCallback } from 'react';

interface SnackbarState {
  open: boolean;
  title: string;
  message: string;
  variant: 'success' | 'error' | 'warning' | 'info';
}

const useStatusSnackbar = () => {
  const [snackbar, setSnackbar] = useState<SnackbarState>({
    open: false,
    title: '',
    message: '',
    variant: 'success',
  });

  const showSnackbar = useCallback(
    (title: string, message: string, variant: 'success' | 'error' | 'warning' | 'info' = 'success') => {
      setSnackbar({
        open: true,
        title,
        message,
        variant,
      });
    },
    []
  );

  const hideSnackbar = useCallback(() => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  }, []);

  return {
    snackbar,
    showSnackbar,
    hideSnackbar,
  };
};

export default useStatusSnackbar;
